export default "__VITE_ASSET__UfKDA1vl__"